import Orders from './List';
import CancelAppointmentFeedback from './Detail/CancelAppointmentFeedback';
import ModifyAppointment from './Detail/UpdateAppointment/FirstSlots';
import ModifyAppointmentWeek from './Detail/UpdateAppointment/Week';
import ModifyAppointmentFeedback from './Detail/UpdateAppointment/Feedback';
import { IRoute } from '../../../utils/navigation/routes';
import OrderDetail from './Detail';
import ModifyAppointmentConfirm from './Detail/UpdateAppointment/Confirm';
import TimeLineOrders from './timeLineOrders';
import FaqsOrders from './FaqsOrders';
import RequiredEquipmentTransfer from './Detail/RequiredEquipmentTransfer';

export const ordersRoutes: IRoute[] = [
    { path: '/profile/orders', element: <Orders /> },
    { path: '/order-detail', element: <OrderDetail /> },
    { path: '/order-detail/cancel/feedback', element: <CancelAppointmentFeedback /> },
    { path: '/order-detail/modify-appointment', element: <ModifyAppointment /> },
    { path: '/order-detail/modify-appointment-week', element: <ModifyAppointmentWeek /> },
    { path: '/order-detail/modify-appointment/confirm', element: <ModifyAppointmentConfirm /> },
    {
        path: '/order-detail/modify-appointment/feedback',
        element: <ModifyAppointmentFeedback />,
    },
    { path: '/order-detail/time-line', element: <TimeLineOrders /> },
    { path: '/profile/orders/faqs', element: <FaqsOrders /> },
    { path: '/order-detail/required-equipment', element: <RequiredEquipmentTransfer /> },
];
